// extracted by mini-css-extract-plugin
export default {"box":"inventorySparesLotListPage_box__Nbn+z"};